<template>
  <div>groupings</div>
</template>
<script>
export default {};
</script>
